export enum AoInspectieOverspanningenUnitCode {
    Aansluitkast = '11',
    Gevelbevestiging = '21',
    Mastbevestiging = '22',
    Spandraadsysteem = '23',
    Armatuur = '24',
}
